import React from 'react'
import Carousel from '../../components/Carousel'
import CompanyCard from '../../components/CompanyCard'
import CompanyGroup from '../../models/CompanyModel'

interface Props {
	companies: CompanyGroup[],
}

const CompanyContainer: React.FC<Props> = ({ companies = [] }) => {
	return (
		<Carousel
			perPage={4.5}
			buttonOut
		>
			{companies.map((company, id) => (
				<CompanyCard
					url={company.url}
					image={company.logo}
					company={company.name}
					key={id}
				/>
			))}
		</Carousel>
	)
}

export default CompanyContainer